import React from 'react'
import { Card } from '@myxplor/ui'

import LocalAsyncStore from '../local-async-store'
import ActiveFilter, { Toggles as ActiveFilterToggles } from '../ui/active-filter'
import List from '../ui/list'
import { RegHolderName } from '../layout'
import { getRegHolder } from '../reg-holder'
import PersonnelList from './views'
import PersonnelSyncButtons from './views/sync-buttons'
import NoPersonnel from './views/empty'
import PersonnelDetails from './details'
import ExpiryMessage from '../ui/expiry-message'

const personnelEndpoint = base_url => `/api${base_url}`

const filterShape = record => {
  let output = {
    name: [record.first_name, record.last_name].join(' '),
    last_name: record.last_name,
  }
  record.ccms_relationships.forEach(relationship => (output[relationship] = relationship))
  return output
}

export const active = ({ active }) => active && active !== 'false'

export const Personnel = ({ personnel, base_url, id, embedded, refresh_personnel }) => (
  <Card
    embedded={embedded}
    title={
      <ActiveFilterToggles>
        <RegHolderName />
      </ActiveFilterToggles>
    }>
    <ExpiryMessage service_id={id}/>
    <PersonnelSyncButtons
      regHolder={getRegHolder(base_url, id)}
      onComplete={() => refresh_personnel(personnelEndpoint(base_url))}
    />

    <ActiveFilter records={personnel.data || []} filterOn={active}>
      <List
        base_url={base_url}
        loading={personnel.loading}
        listComponent={PersonnelList}
        detailComponent={PersonnelDetails}
        emptyComponent={NoPersonnel}
        idField={'id'}
        filterOn={filterShape}
      />
    </ActiveFilter>
  </Card>
)

export default LocalAsyncStore('personnel', Personnel, ({ base_url }) =>
  personnelEndpoint(base_url)
)



// WEBPACK FOOTER //
// ./src/personnel/container.js